import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: "",
};

export const errorMessageSlice = createSlice({
    name: "errorMessage",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToErrorMessage: (state, action) => {
            state.data = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { addToErrorMessage } = errorMessageSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.errorMessage.value)`
export const selectErrorMessage = (state) => state.errorMessage;

export default errorMessageSlice.reducer;
